export const browserSupportsWebgl = () => {
  const canvas = document.createElement('canvas');

  // Get WebGLRenderingContext from canvas element.
  const gl = canvas.getContext('webgl');

  return gl instanceof WebGLRenderingContext;
};
